<template>
    <SettingsPositions :client="client" @updated="onSetupComplete"/>
</template>
<script>
    import SettingsPositions from '@/pages/client/Settings/Positions'

    export default {
        props: ['client', 'setupStatus'],
        components: {SettingsPositions},
        data() {
            return {}
        },
        methods: {
            onSetupComplete() {
                this.$store.dispatch('START_LOADING')
                this.$api.post(`/clients/${this.client.id}/setup-status`, {step: 'positions'}).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$emit('refreshClient')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showError(errors.__all__)
                })
            },
        },
    }
</script>
